/**
 * Live Transcription Domain
 * The transcript the voice monitor shows a moderator: its listener adds each
 * final line, and its Clear empties it.
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { forgetAtSessionEnd } from '../../../lib/session-end';

interface TranscriptEntry {
  id: string;
  speaker_identity: string;
  speaker_name: string;
  text: string;
  language?: string;
  timestamp: string;
}

interface LiveTranscriptionState {
  transcripts: TranscriptEntry[];
  addTranscript: (entry: TranscriptEntry) => void;
  clearTranscripts: () => void;
}

const initialState = {
  transcripts: [],
};

export const useLiveTranscriptionStore = create<LiveTranscriptionState>()(
  devtools(
    (set) => ({
      ...initialState,

      addTranscript: (entry) => set(
        (state) => ({
          transcripts: [...state.transcripts, entry].slice(-100) // Keep last 100
        }),
        false,
        'addTranscript'
      ),
      
      clearTranscripts: () => set({ transcripts: [] }, false, 'clearTranscripts'),
    }),
    { name: 'LiveTranscriptionStore' }
  )
);

// What the students said is never the next sign-in's to read.
forgetAtSessionEnd(() => useLiveTranscriptionStore.getState().clearTranscripts());
